<template>
  <div class="vscroll login-layout md-layout md-gutter md-alignment-center-center">
    <div v-if="getPermission.acnit.view || getPermission.stc.view" id="middlebar"></div>
    <div v-if="getPermission.acnit.view" id="leftbox">
      <div class="centerdiv">
         <md-label class="label_text">APPLE</md-label>
      </div>
      <dv class="centerdiv2">
         <md-label class="label_text">IOS</md-label>
      </dv>
    </div>
    <div v-if="getPermission.acnit.view" id="middlebox"></div>  
    <div v-if="getPermission.acnit.view" id="rightbox">
      <div class="devlink">
        <a :href="appLinks.ios.stcDEV" target="_blank">
          <h1>DEV</h1>
        </a>
      </div>
      <div class="devQR">
        <qrcode-vue :value="appLinks.ios.stcDEV"/>
      </div>
      <div class="qaslink">
        <a :href="appLinks.ios.stcQAS" target="_blank">
          <h1>QAS</h1>
        </a>
      </div>
      <div class="qasQR">
        <qrcode-vue :value="appLinks.ios.stcQAS"/>
      </div>
      <div class="prdlink">
        <a :href="appLinks.ios.stcPRD" target="_blank">
          <h1>PRD</h1>
        </a>
      </div>
      <div class="prdQR">
        <qrcode-vue :value="appLinks.ios.stcPRD"/>
      </div>
    </div>
    <div v-if="!getPermission.acnit.view && getPermission.stc.view" id="leftbox">
      <div class="centerdiv">
         <md-label class="label_text">APPLE</md-label>
      </div>
      <div class="centerdiv2">
         <md-label class="label_text">IOS</md-label>
      </div>
    </div>
    <div v-if="!getPermission.acnit.view && getPermission.stc.view" id="middlebox"></div>  
    <div v-if="!getPermission.acnit.view && getPermission.stc.view" id="rightbox">
      <div class="qaslink1">
        <a :href="appLinks.ios.stcQAS" target="_blank">
          <h1>QAS</h1>
        </a>
      </div>
      <div class="qasQR1">
        <qrcode-vue :value="appLinks.ios.stcQAS"/>
      </div>
      <div class="prdlink1">
        <a :href="appLinks.ios.stcPRD" target="_blank">
          <h1>PRD</h1>
        </a>
      </div>
      <div class="prdQR1">
        <qrcode-vue :value="appLinks.ios.stcPRD"/>
      </div>
    </div>
    <div v-if="getPermission.acnit.view || getPermission.stc.view" id="middlebar"></div>
    <div v-if="getPermission.acnit.view" id="leftbox">
      <div class="centerdiv1">
        <md-label class="label_text">ANDROID</md-label>
      </div>
    </div>
    <div v-if="getPermission.acnit.view" id="middlebox"></div>  
    <div v-if="getPermission.acnit.view" id="rightbox">
      <div class="devlink">
        <a :href="appLinks.android.stcDEV" target="_blank">
          <h1>DEV</h1>
        </a>
      </div>
      <div class="devQR">
        <qrcode-vue :value="appLinks.android.stcDEV"/>
      </div>
      <div class="qaslink">
        <a :href="appLinks.android.stcQAS" target="_blank">
          <h1>QAS</h1>
        </a>
      </div>
      <div class="qasQR">
        <qrcode-vue :value="appLinks.android.stcQAS"/>
      </div>
      <div class="prdlink">
        <a :href="appLinks.android.stcPRD" target="_blank">
          <h1>PRD</h1>
        </a>
      </div>
      <div class="prdQR">
        <qrcode-vue :value="appLinks.android.stcPRD"/>
      </div>
      </div>
      <div v-if="!getPermission.acnit.view && getPermission.stc.view" id="leftbox">
      <div class="centerdiv1">
        <md-label class="label_text">ANDROID</md-label>
      </div>
    </div>
    <div v-if="!getPermission.acnit.view && getPermission.stc.view" id="middlebox"></div>  
    <div v-if="!getPermission.acnit.view && getPermission.stc.view" id="rightbox">
      <div class="qaslink1">
        <a :href="appLinks.android.stcQAS" target="_blank">
          <h1>QAS</h1>
        </a>
      </div>
      <div class="qasQR1">
        <qrcode-vue :value="appLinks.android.stcQAS"/>
      </div>
      <div class="prdlink1">
        <a :href="appLinks.android.stcPRD" target="_blank">
          <h1>PRD</h1>
        </a>
      </div>
      <div class="prdQR1">
        <qrcode-vue :value="appLinks.android.stcPRD"/>
      </div>

    </div>

    <div v-if="getPermission.acnit.view || getPermission.fsi.view || getPermission.ccic.view" id="middlebar"></div>
    <!--<div v-if="!getPermission.acnit.view" id="leftbox">-->
    <div v-if="getPermission.acnit.view || getPermission.fsi.view || getPermission.ccic.view" id="leftbox">
      <div class="centerdiv1">
        <md-label class="label_text">CCIC</md-label>
      </div>
    </div>
    <!--<div v-if="!getPermission.acnit.view" id="middlebox"></div>-->
    <div v-if="getPermission.acnit.view || getPermission.fsi.view || getPermission.ccic.view" id="middlebox"></div>  
    <!--<div v-if="!getPermission.acnit.view" id="rightbox">-->
    <div v-if="getPermission.acnit.view" id="rightbox">  
      <div class="devlink1">
        <a :href="appLinks.ccic.ccicDEV" target="_blank">
          <h1>DEV</h1>
        </a>
      </div>
      <div class="devQR1">
        <qrcode-vue  :value="appLinks.ccic.ccicDEV"/>
      </div>
      <div class="qaslink1">
        <a :href="appLinks.ccic.ccicQAS" target="_blank">
          <h1>QAS</h1>
        </a>
      </div>
      <div class="qasQR1">
        <qrcode-vue :value="appLinks.ccic.ccicQAS"/>
      </div>
      <div class="prdlink1">
        <a :href="appLinks.ccic.ccicPRD" target="_blank">
          <h1>PRD</h1>
        </a>
      </div>
      <div class="prdQR1">
        <qrcode-vue :value="appLinks.ccic.ccicPRD"/>
      </div>

    </div>
    <div v-if="(getPermission.fsi.view || getPermission.ccic.view) && !getPermission.acnit.view" id="rightbox">  
      <div class="qaslink2">
        <a :href="appLinks.ccic.ccicQAS" target="_blank">
          <h1>QAS</h1>
        </a>
      </div>
      <div class="qasQR2">
        <qrcode-vue :value="appLinks.ccic.ccicQAS"/>
      </div>
      <div class="prdlink2">
        <a :href="appLinks.ccic.ccicPRD" target="_blank">
          <h1>PRD</h1>
        </a>
      </div>
      <div class="prdQR2">
        <qrcode-vue :value="appLinks.ccic.ccicPRD"/>
      </div>

    </div>

    <!--
    <table width="80%">
      <tr><th colspan="5" style="height:50px; background-color: blanchedalmond; width: 100%; text-align:center; font-size: 25px; justify-content: center; align-items: center;"><span style="width:100%; margin-top: 10px;">ANDROID</span></th></tr>
      <tr>
        <th>
          <div>
          <a :href="appLinks.android.stc" target="_blank">
          <h4>Android STC DEV</h4>
          <qrcode-vue :value="appLinks.android.stcDEV"/>
        </a>
          </div>
        </th>
        <th>
          <div style="width: 100px;"></div>
        </th>
        <th>
          <a :href="appLinks.android.stc" target="_blank">
          <h4>Android STC QAS</h4>
          </a>
          <qrcode-vue :value="appLinks.android.stcQAS"/>
        </th>
        <th>
          <div style="width: 100px;"></div>
        </th>
        <th>
          <a :href="appLinks.android.stc" target="_blank">
          <h4>Android STC PRD</h4>
          <qrcode-vue :value="appLinks.android.stcPRD"/>
        </a>

        </th>
      </tr>
      <tr><th></th></tr>
      <tr style="height: 50px;"><th></th></tr>
      <tr><th colspan="5" style="height:50px; background-color: blanchedalmond; text-align:center; font-size: 25px; justify-content: center; align-items: center;"><span>APPLE IOS</span></th></tr>
      <tr>
        <th>
          <a :href="appLinks.ios.stc" target="_blank">
          <h4>IOS STC DEV</h4>
          <qrcode-vue :value="appLinks.ios.stcDEV"/>
        </a>
        </th>
        <th>
          <div style="width: 100px;"></div>
        </th>
        <th>
          <a :href="appLinks.ios.stc" target="_blank">
          <h4>IOS STC QAS</h4>
          <qrcode-vue :value="appLinks.ios.stcQAS"/>
        </a>
        </th>
        <th>
          <div style="width: 100px;"></div>
        </th>
        <th>
          <a :href="appLinks.ios.stc" target="_blank">
          <h4>IOS STC PRD</h4>
          <qrcode-vue :value="appLinks.ios.stcPRD"/>
        </a>
        </th>
      </tr>
    </table>
  -->
    <!--
    <div>
    <div class="md-layout-item md-size-15">
    </div>
    <div class="md-layout md-gutter md-alignment-center-space-around" style="padding: 0px 8px 8px 8px; text-align: center">
      <div class="md-layout-item md-size-25 md-small-size-100">
        <a :href="appLinks.android.stc" target="_blank">
          <h4>Android STC DEV</h4>
          <qrcode-vue :value="appLinks.android.stcDEV"/>
        </a>
      </div>
      <div class="md-layout-item md-size-25 md-small-size-100">
        <a :href="appLinks.android.stc" target="_blank">
          <h4>Android STC QAS</h4>
          <qrcode-vue :value="appLinks.android.stcQAS"/>
        </a>
      </div>
      <div class="md-layout-item md-size-25 md-small-size-100">
        <a :href="appLinks.android.stc" target="_blank">
          <h4>Android STC PRD</h4>
          <qrcode-vue :value="appLinks.android.stcPRD"/>
        </a>
      </div>
      </div>
      </div>

      <div style="margin-top: 200px; margin-left: 50px;">
      <div class="md-layout md-gutter md-alignment-center-space-around" style="padding: 0px 8px 8px 8px; text-align: center">
      <div class="md-layout-item md-size-25 md-small-size-100">
        <a :href="appLinks.ios.stc" target="_blank">
          <h4>IOS STC DEV</h4>
          <qrcode-vue :value="appLinks.ios.stcDEV"/>
        </a>
      </div>
      <div class="md-layout-item md-size-25 md-small-size-100">
        <a :href="appLinks.ios.stc" target="_blank">
          <h4>IOS STC QAS</h4>
          <qrcode-vue :value="appLinks.ios.stcQAS"/>
        </a>
      </div>
      <div class="md-layout-item md-size-25 md-small-size-100">
        <a :href="appLinks.ios.stc" target="_blank">
          <h4>IOS STC PRD</h4>
          <qrcode-vue :value="appLinks.ios.stcPRD"/>
        </a>
      </div>

    </div>
    <div class="md-layout-item md-size-15">
    </div>
  </div>
-->
</div>
</template>
<style type="text/css">
  #leftbox { 
    float:left;
    background: #54777d;
    width:15%;
    height:200px;
  }
  #middlebox{
    float:left;
    background: #eadb9d;
    width: 1%;
    height: 200px;
  }
  #rightbox{
    float:right;
    background: #e7e3c5;
    width:84%;
    height:200px;
  }
  #middlebar{
    width:100%;
    height: 50px;
  }
  .label_text{
    font-size: 25px;
    color: white;
    font-weight: bold;
  }
  .centerdiv{
    /*border: 5px solid;*/
    position: relative;
    top: 30%;
    /*transform: translate(0, -50%);*/
    left: 25%;
    padding: 5px;
  }
  .centerdiv1{
    /*border: 5px solid;*/
    position: relative;
    top: 30%;
    /*transform: translate(0, -50%);*/
    left: 25%;
    padding: 5px;
  }
  .centerdiv2{
    /*border: 5px solid;*/
    position: relative;
    top: 30%;
    /*transform: translate(0, -50%);*/
    left: 33%;
    padding: 10px;

  }
  .devlink{
    /*border: 5px solid;*/
    top: 15%;
    left: 9%;
    width: 10%;
    position: relative
  }
  .devQR{
    /*border: 5px solid;*/
    top: 28%;
    left: 7%;
    width: 10%;
    position: relative;
  }
  .qaslink{
    /*border: 5px solid;*/
    top: 10%;
    margin-top: -103px;
    left: 44%;
    width: 10%;
    position: relative;
  }
  .qasQR{
    /*border: 5px solid;*/
    top: 40%;
    margin-top: -35px;
    left: 42%;
    width: 10%;
    position: relative;
  }
  .prdlink{
    /*border: 5px solid;*/
    top: 23%;
    margin-top: -103px;
    left: 79%;
    width: 10%;
    position: relative;
  }
  .prdQR{
    /*border: 5px solid;*/
    top: 53%;
    margin-top: -35px;
    left: 77%;
    width: 10%;
    position: relative;
  }
  .devlink1{
    /*border: 5px solid;*/
    top: 12%;
    margin-top: 10px;
    left: 9%;
    width: 10%;
    position: relative;
  }
  .devQR1{
    /*border: 5px solid;*/
    top: 40%;
    margin-top: -35px;
    left: 7%;
    width: 10%;
    position: relative;
  }
  .qaslink1{
    /*border: 5px solid;*/
    top: -32%;
    margin-top: 10px;
    left: 44%;
    width: 10%;
    position: relative;
  }
  .qasQR1{
    /*border: 5px solid;*/
    top: 12%;
    margin-top: -65px;
    left: 42.3%;
    width: 10%;
    position: relative;
  }
  .prdlink1{
    /*border: 5px solid;*/
    top: -3%;
    margin-top: -103px;
    left: 78.3%;
    width: 10%;
    position: relative;
  }
  .prdQR1{
    /*border: 5px solid;*/
    top: 25%;
    margin-top: -35px;
    left: 77%;
    width: 10%;
    position: relative;
  }
  .qaslink2{
    /*border: 5px solid;*/
    top: 10%;
    margin-top: 10px;
    left: 25%;
    width: 10%;
    position: relative;
  }
  .qasQR2{
    /*border: 5px solid;*/
    top: 40%;
    margin-top: -35px;
    left: 23%;
    width: 10%;
    position: relative;
  }
  .prdlink2{
    /*border: 5px solid;*/
    top: 23%;
    margin-top: -103px;
    left: 65%;
    width: 10%;
    position: relative;
  }
  .prdQR2{
    /*border: 5px solid;*/
    top: 53%;
    margin-top: -35px;
    left: 63%;
    width: 10%;
    position: relative;
  }
  h1{
    font-size: 20px;
    font-weight: bold;
  }
  .vscroll{
    height: 1200px;
    max-height: 87vh;
    width: 100%;
    overflow-y: auto;
    position: sticky;
  }
</style>

<script>
  import Config from '../config';
  import QrcodeVue from 'qrcode.vue';
  import { mapGetters } from "vuex";

  export default {
    data: () => ({
      // appLinks: Config.appLinks,
        appLinks:{
          android:{
            stcDEV: 'https://app-s3-walmart.s3.us-west-2.amazonaws.com/STCAPP/STCApp.apk',
            stcQAS: 'https://app-s3-walmart.s3.us-west-2.amazonaws.com/STCAPPQAS/STCAppQAS.apk',
            stcPRD: 'https://app-s3-walmart.s3.us-west-2.amazonaws.com/STCAPPPRD/STCAppPRD.apk'
          },
          ios:{
            stcDEV: 'https://app-s3-walmart.s3.us-west-2.amazonaws.com/STCAPPDEV/main.html',
            stcQAS: 'https://app-s3-walmart.s3.us-west-2.amazonaws.com/STCAPPQAS/main.html',
            stcPRD: 'https://app-s3-walmart.s3.us-west-2.amazonaws.com/STCAPPPRD/main.html'
          },
          ccic:{
            ccicDEV: 'https://app-s3-walmart.s3.us-west-2.amazonaws.com/CCICDEV/main.html',
            ccicQAS: 'https://app-s3-walmart.s3.us-west-2.amazonaws.com/CCICQAS/main.html',
            ccicPRD: 'https://app-s3-walmart.s3.us-west-2.amazonaws.com/CCICPRD/main.html' 
          },
        },
        isIT:false
    }),
    components: {
      QrcodeVue,
    },
    computed: {
      ...mapGetters([
        "getPermission",
        "getUserProfile",
        "getRole",
      ]),
    },
  }
</script>